import isAfter from "date-fns/isAfter";

export default class Task {
  public constructor(
    public id: number,
    public name: string,
    public type: string,
    public project: string,
    public done: boolean,
    public dueDate: Date | null,
    public userName: string,
    public date: string | null,
    public time: string | null,
    public users: string | null,
    public projectId: string | null,
    public canEditProject: boolean,
    public isOwner: boolean,
    public canEditName: boolean
  ) {}

  /**
   * 指定した日付が期限を過ぎているかどうか
   */
  public isOverdue(date: Date): boolean {
    if (this.done || !this.dueDate) return false;
    return isAfter(date, this.dueDate);
  }
}
